/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { BannerViewModel } from "../types/BannerViewModel.ts";
import { bannerClassStudentViewModelSchema } from "./bannerClassStudentViewModelSchema.ts";
import { eBannerPositionSchema } from "./eBannerPositionSchema.ts";
import { eBannerPrioritySchema } from "./eBannerPrioritySchema.ts";

export const bannerViewModelSchema = z.object({
  id: z.optional(z.number().int().describe("ID do banner.")),
  companyId: z
    .number()
    .int()
    .describe("ID da empresa associada. Nulo para banners globais.")
    .nullish(),
  companyName: z
    .string()
    .describe("Nome da empresa associada. Nulo para banners globais.")
    .nullish(),
  title: z.string().describe("Título do banner.").nullish(),
  showTitle: z.optional(
    z.boolean().describe("Indica se o título deve ser exibido sobre o banner."),
  ),
  startDate: z
    .string()
    .datetime()
    .describe("Data de início de exibição. Nulo significa sem restrição.")
    .nullish(),
  endDate: z
    .string()
    .datetime()
    .describe("Data de término de exibição. Nulo significa sem restrição.")
    .nullish(),
  position: z.optional(
    z
      .lazy(() => eBannerPositionSchema)
      .describe("1 = Top | 2 = MiddleStart | 3 = MiddleEnd | 4 = Bottom | "),
  ),
  duration: z.optional(
    z.number().int().describe("Duração de exibição em segundos no carrossel."),
  ),
  priority: z.optional(
    z
      .lazy(() => eBannerPrioritySchema)
      .describe(
        "1 = VeryLow | 2 = Low | 3 = Medium | 4 = High | 5 = VeryHigh | ",
      ),
  ),
  filePath: z
    .string()
    .describe(
      "URL pública da imagem ou vídeo principal. Nulo quando nenhum arquivo foi enviado.",
    )
    .nullish(),
  filePathMobile: z
    .string()
    .describe(
      "URL pública da imagem ou vídeo mobile. Nulo quando nenhum arquivo foi enviado.",
    )
    .nullish(),
  url: z
    .string()
    .describe("URL de destino ao clicar no banner. Opcional.")
    .nullish(),
  general: z.optional(
    z
      .boolean()
      .describe(
        "Quando true, exibe para todos os alunos. Quando false, apenas para as turmas vinculadas.",
      ),
  ),
  isMonograph: z.optional(
    z
      .boolean()
      .describe("Indica se o banner é destinado a alunos em monografia."),
  ),
  isMonitor: z.optional(
    z.boolean().describe("Indica se o banner é destinado a monitores."),
  ),
  allowedEnrollmentStatus: z
    .string()
    .describe(
      "Status de matrícula permitidos (CSV de EEnrollmentStatus). Opcional.",
    )
    .nullish(),
  active: z.optional(z.boolean().describe("Indica se o banner está ativo.")),
  classStudents: z
    .array(z.lazy(() => bannerClassStudentViewModelSchema))
    .describe("Turmas vinculadas ao banner. Lista vazia para banners gerais.")
    .nullish(),
}) as unknown as ToZod<BannerViewModel>;
